import { defineMessages } from 'react-intl';

export default defineMessages({
  YES: {
    defaultMessage: 'Oui',
  },

  NO: {
    defaultMessage: 'Non',
  },

  THANKS_REGISTERED: {
    defaultMessage:
      'Merci pour votre réponse ! Envoyez-nous votre justificatif d’inscription à <a>{email}</a> afin que nous puissions le prendre en compte.',
  },

  THANKS_NOT_REGISTERED: {
    defaultMessage: 'Merci pour votre réponse ! Ce sera peut-être pour la prochaine session.',
  },
} as const);
